












































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { QuillEditor, IntroItem } from '@/common/interface';
import { replaceString } from '@/common/utils/dealWithString';

const moveDown = require('@/assets/img/move-down.png');
const moveUp = require('@/assets/img/move-up.png');
const deleteIcon = require('@/assets/img/delete.png');
const addText = require('@/assets/img/add-text.png');
const addImg = require('@/assets/img/add-img.png');
const addVedio = require('@/assets/img/add-vedio.png');

export default class MediaContentList extends Vue{
  @Prop() list: any;
  

  moveDown: string = moveDown;
  moveUp: string = moveUp;
  deleteIcon: string = deleteIcon;
  addText: string = addText;
  addImg: string = addImg;
  addVedio: string = addVedio;


  get mediaList() {
    console.log(this.list,'333');
    return this.list || [];
  }

  // 下移项目
  handleDownItem(index: number) {
    // this.isScroll = false;
    // this.downSectionPrizeIntros(index);
  }
}
